/* istanbul ignore file */
import React, { useRef, useEffect, useState } from 'react'

import ArrowButton from '@components/CompactTripCard/Carousel/ArrowButton'

import '@components/CompactTripCard/Carousel/styles.scss'

interface CarouselProps {
  children: React.ReactNode
  secondClassFares: Fare[]
  firstClassFares: Fare[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const Carousel = ({
  children,
  secondClassFares,
  firstClassFares,
  currentPage,
  totalPages,
  onPageChange,
}: CarouselProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isTransitioning, setIsTransitioning] = useState(false)

  const scroll = (direction: 'left' | 'right') => {
    if (isTransitioning) return

    if (direction === 'left' && currentPage > 0) {
      setIsTransitioning(true)
      onPageChange(currentPage - 1)
    } else if (direction === 'right' && currentPage < totalPages - 1) {
      setIsTransitioning(true)
      onPageChange(currentPage + 1)
    }
  }

  useEffect(() => {
    if (isTransitioning) {
      const timer = setTimeout(() => {
        setIsTransitioning(false)
      }, 400)
      return () => clearTimeout(timer)
    }
  }, [isTransitioning, currentPage])

  const hasMoreThanThreeInEitherSection = secondClassFares.length > 3 || firstClassFares.length > 3
  const canScrollLeft = currentPage > 0 && !isTransitioning
  const canScrollRight = currentPage < totalPages - 1 && !isTransitioning
  const showLeftArrow = hasMoreThanThreeInEitherSection && (canScrollLeft || canScrollRight)
  const showRightArrow = hasMoreThanThreeInEitherSection && (canScrollLeft || canScrollRight)
  const isTransitioningClass = isTransitioning ? 'transitioning' : ''

  return (
    <div className="carousel-wrapper">
      {showLeftArrow && (
        <ArrowButton
          direction="left"
          onClick={() => scroll('left')}
          disabled={!canScrollLeft}
          isTransitioning={isTransitioning}
        />
      )}
      <div className="carousel-container" ref={containerRef}>
        <div className={`carousel-content ${isTransitioningClass}`}>{children}</div>
      </div>
      {showRightArrow && (
        <ArrowButton
          direction="right"
          onClick={() => scroll('right')}
          disabled={!canScrollRight}
          isTransitioning={isTransitioning}
        />
      )}
    </div>
  )
}

export default Carousel
